import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon';

export const LocationIcon = (props: { color?: string }) => {
  return (
    <FontAwesomeIcon icon={faMapMarkerAlt} color={props.color || 'black'} />
  )
}
